<template>
  <div class="rounded-full mr-1 mb-1 pl-1 pr-1 border-2" :class="typeClass">
    <el-tooltip :open-delay="200">
      <div slot="content">
        <div class="max-w-sm max-h-500p overflow-auto">
          <div>
            <ul>
              <li>{{ group.Propietario ? $t('groups.owner') : '' }}</li>
                <li>{{ `${$t('configurations.tipo_grupo')}: ${tipoGrupo}` }}</li>
            </ul>
          </div>
        </div>
      </div>
      <span>
        <base-icon v-if="group.Propietario" name="key" size="xs"/>
        {{ group.Nombre }}
      </span>
    </el-tooltip>  
  </div>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  name: 'rounded-group',
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
            
    }
  },
  computed: {
    idTipo: function () {
      return this.group.idTipo
    },
    typeClass: function () {
      return {
        'bg-primary-500 dark:bg-darkblue text-white group-pool': this.idTipo === 1,
        'bg-primary-50 dark:bg-darkblue text-primary group-border': this.idTipo === 2,
        'bg-secondary-600 dark:bg-secondary-600 text-white group-reparto': this.idTipo === 3,
      }
    },
    tipoGrupo: function () {
      const tiposGrupo = this.$store.getters['config/TIPOS_GRUPO']
      const tipo = tiposGrupo.find(x => x.id === this.idTipo)
      if (tipo?.name) {
        return tipo.name
      }
      console.warn(i18n.t('feedback.warning.bad_enum_value_warn', { field: 'TipoGrupo', value: this.idTipo }))
      return this.idTipo
    },
  },
}
</script>

<style>

</style>
